import { useState as s, useEffect as i } from "react";
const a = [
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Enter",
  "Escape",
  "Space"
];
function w() {
  const [t, e] = s(!1);
  return i(() => {
    const n = (r) => {
      a.includes(r.key) && e(!0);
    }, o = () => {
      e(!1);
    };
    return window.addEventListener("keydown", n), window.addEventListener("mousedown", o), () => {
      window.removeEventListener("keydown", n), window.removeEventListener("mousedown", o);
    };
  }, []), t;
}
export {
  w as useKeyboardNavigationDetected
};
